import React, { useEffect, useState } from "react";
import { Bell, Check } from "lucide-react";
import { PageHeader, Loader, Empty } from "@/components/shared";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import { fmtDate } from "@/lib/format";

export default function Notifications() {
  const { t } = useI18n();
  const [items, setItems] = useState(null);
  const load = () => api.get("/notifications").then(({ data }) => setItems(data)).catch(() => {});
  useEffect(() => { load(); }, []);
  if (!items) return <Loader />;

  const markRead = async () => { await api.post("/notifications/read"); load(); };

  return (
    <div>
      <PageHeader title={t("notifications")}
        action={items.some((n) => !n.read) && <Button onClick={markRead} data-testid="mark-read-button" className="bg-white/5 border border-white/10 hover:bg-white/10"><Check className="w-4 h-4 me-1" />{t("mark_all_read")}</Button>} />
      {items.length === 0 ? <Empty label={t("no_notifications")} /> : (
        <div className="space-y-3">
          {items.map((n) => (
            <div key={n.id} className={`ec-card p-4 flex gap-4 ${!n.read ? "border-orange-500/40" : ""}`} data-testid={`notif-${n.id}`}>
              <div className="w-10 h-10 rounded-xl bg-orange-500/10 flex items-center justify-center shrink-0"><Bell className="w-5 h-5 text-orange-400" /></div>
              <div className="flex-1">
                <div className="flex items-center justify-between gap-2">
                  <p className="font-semibold text-white text-sm">{n.title}</p>
                  {!n.read && <span className="w-2 h-2 rounded-full bg-orange-500 shrink-0" />}
                </div>
                <p className="text-sm text-gray-400 mt-1">{n.body}</p>
                <p className="text-xs text-gray-600 mt-1">{fmtDate(n.created_at)}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
